// Author Shi Wenlong
// Date 2021-07-10 14:39:46

class SithMesQualityToolManage {
    constructor({
                    id = null,
                    type = '',
                    serialNumberNew = '',
                    serialNumberOld = '',
                    name = '',
                    specification = '',
                    measuringRage = '',
                    testingPeriod = '',
                    testingDate = '',
                    validUntil = '',
                    certificateNumber = '',
                    testingType = '',
                    preserver = '',
                    storageLoc = '',
                    status = '',
                    remark = '',
                    checkReport = '',
                    checkReportList = ''
                }
                = {}) {
        this.id = id;
        this.type = type;
        this.serialNumberNew = serialNumberNew;
        this.serialNumberOld = serialNumberOld;
        this.name = name;
        this.specification = specification;
        this.measuringRage = measuringRage;
        this.testingPeriod = testingPeriod;
        this.testingDate = testingDate;
        this.validUntil = validUntil;
        this.certificateNumber = certificateNumber;
        this.testingType = testingType;
        this.preserver = preserver;
        this.storageLoc = storageLoc;
        this.status = status;
        this.remark = remark;
        this.checkReport = checkReport;
        this.checkReportList = checkReportList;
    }
}

function newEntity() {
    return new SithMesQualityToolManage();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'type',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.type',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'serialNumberNew',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.serialNumberNew',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'serialNumberOld',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.serialNumberOld',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'epcCode',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.epcCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'name',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.name',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'specification',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.specification',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'measuringRage',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.measuringRage',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'testingPeriod',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.testingPeriod',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'testingDate',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.testingDate',
            sortable: true,
            form: {
                type: 'datepicker'
            }
        },
        {
            key: 'validUntil',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.validUntil',
            sortable: true,
            form: {
                type: 'datepicker',
                customClass: (row) => {
                    //提前四十五天提醒，量具该送检了(2025.02.14 按岳旭要求修改倒数提醒变红天数)
                    let untilDate = new Date(row.validUntil).getTime();
                    let endDate = new Date().setDate(new Date().getDate() + 45);
                    if (untilDate <= endDate) return 'bg-danger text-white';
                    return ""
                }
            },
        },
        {
            key: 'certificateNumber',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.certificateNumber',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'testingType',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.testingType',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'preserver',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.preserver',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'storageLoc',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.storageLoc',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'status',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.status',
            sortable: true,
            form: {
                type: 'select',
                options: [{
                    value: '在库',
                    text: '在库'
                },
                    {
                        value: '送检',
                        text: '送检'
                    },
                    {
                        value: '等待报废',
                        text: '等待报废'
                    },
                    {
                        value: '报废',
                        text: '报废'
                    },
                    {
                        value: '借出',
                        text: '借出'
                    }]
            },
        },
        {
            key: 'remark',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.remark',
            sortable: true,
            form: {
                type: 'textarea'
            }
        },
        {
            key: 'checkReportList',
            label: 'label.sith.quality.sithMesQualityToolManage.grid.checkReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment'
            }
        }
    ])
}

const filter = {
    idFilter: "",
    idListFilter: "",
    typeFilter: "",
    serialNumberNewFilter: "",
    serialNumberOldFilter: "",
    epcCodeFilter: '',
    nameFilter: "",
    specificationFilter: "",
    measuringRageFilter: "",
    testingPeriodFilter: "",
    testingDateRteFilter: "",
    testingDateLteFilter: "",
    validUntilRteFilter: "",
    validUntilLteFilter: "",
    certificateNumberFilter: "",
    testingTypeFilter: "",
    preserverFilter: "",
    storageLocFilter: "",
    statusFilter: "",
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'typeFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.type',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'serialNumberNewFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.serialNumberNew',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'serialNumberOldFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.serialNumberOld',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'nameFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.name',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'specificationFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.specification',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'measuringRageFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.measuringRage',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'testingPeriodFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.testingPeriod',
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'testingDateRteFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.testingDateRte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'testingDateLteFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.testingDateLte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'validUntilRteFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.validUntilRte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'validUntilLteFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.validUntilLte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'certificateNumberFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.certificateNumber',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'testingTypeFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.testingType',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'preserverFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.preserver',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'storageLocFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.storageLoc',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.sith.quality.sithMesQualityToolManage.filter.status',
        disabled: false,
        form: {
            type: 'select',
            options: [{
                value: '在库',
                text: '在库'
            },
                {
                    value: '送检',
                    text: '送检'
                },
                {
                    value: '等待报废',
                    text: '等待报废'
                },
                {
                    value: '报废',
                    text: '报废'
                },
                {
                    value: '借出',
                    text: '借出'
                }]
        },
    },
];


const entityFormConfigs = [
    {
        key: 'type',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'serialNumberNew',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.serialNumberNew',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'serialNumberOld',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.serialNumberOld',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'name',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'specification',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.specification',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'measuringRage',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.measuringRage',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'testingPeriod',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.testingPeriod',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'testingDate',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.testingDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'validUntil',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.validUntil',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'certificateNumber',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.certificateNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'testingType',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.testingType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'preserver',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.preserver',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'storageLoc',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.storageLoc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'status',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.status',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: [{
                value: '在库',
                text: '在库'
            },
                {
                    value: '送检',
                    text: '送检'
                },
                {
                    value: '等待报废',
                    text: '等待报废'
                },
                {
                    value: '报废',
                    text: '报废'
                },
                {
                    value: '借出',
                    text: '借出'
                }]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea'
        }
    },
    {
        key: 'checkReportList',
        label: 'label.sith.quality.sithMesQualityToolManage.entity.checkReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment'
            , correspondingField: 'checkReport'
        }
    }
]

export {
    SithMesQualityToolManage, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
